export default __webpack_public_path__ + "static/pivot-5b9764fecb4db4f1450d8632a422aaaa.png";